import { render, staticRenderFns } from "./doso.html?vue&type=template&id=4bc63552&"
import script from "./doso.js?vue&type=script&lang=js&"
export * from "./doso.js?vue&type=script&lang=js&"
import style0 from "./doso.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports